module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "5.b8f67e1c.png";